/* eslint-disable @typescript-eslint/camelcase */

import { TaxValidationConfig } from "@/domain/client/validation";
import { BcsFlag, FcsFlag } from "../unleash";

const FcsPermissionClient = {
  permission_client_enable: new FcsFlag.Flag(false),
  permission_client_management_detail_view: new FcsFlag.Flag(false),
  permission_client_management_detail_edit: new FcsFlag.Flag(false),
  permission_client_management_add: new FcsFlag.Flag(false),
  permission_client_management_detail_renewal_approval: new FcsFlag.Flag(false),
  permission_client_registration_detail_view: new FcsFlag.Flag(false),
  permission_client_registration_detail_edit: new FcsFlag.Flag(false),
  permission_client_registration_add: new FcsFlag.Flag(false),
  permission_client_registration_detail_renewal_approval: new FcsFlag.Flag(false),
  permission_client_management_renew_rate: new FcsFlag.Flag(false),
  permission_client_management_update_live_rate: new FcsFlag.Flag(false),
  client_v2_enable: new FcsFlag.Flag(false),
  rates_retry_upload_enabled: new FcsFlag.Flag(false),
  partially_status_current_rate: new FcsFlag.Flag(false),
  permission_client_management_edit_bank_account: new FcsFlag.Flag(false),
  permission_client_management_detail_ktp_npwp_view: new FcsFlag.Flag(false),
  permission_client_management_detail_pks_view: new FcsFlag.Flag(false),
  permission_client_management_detail_frp_view: new FcsFlag.Flag(false),
  permission_client_management_detail_custom_rates_view: new FcsFlag.Flag(false),
  partially_status_renewal_rate: new FcsFlag.Flag(false),
  abort_upload_rate_enabled: new FcsFlag.Flag(false),
  permission_period_date_time: new FcsFlag.Flag(false),
  permission_client_management_download_rate: new FcsFlag.Flag(false),
  permission_client_rate_history_view: new FcsFlag.Flag(false)
};

const BcsPermissionClient = {
  config_tax_validation_by_country: new BcsFlag.JSONFlag([
    {
      countryCode: "ID",
      validationEnabled: true,
      minLength: 16,
      maxLength: 16,
      numericOnly: true,
      errorMessage: "Masukan Nomor NPWP",
    },
    {
      countryCode: "MY",
      validationEnabled: false,
      minLength: 0,
      maxLength: 0,
      numericOnly: false,
      errorMessage: "",
    },
  ] as TaxValidationConfig[]),
  config_rate_listing_row_limit: new FcsFlag.NumberFlag(12)
};

export const FlagsPermissionClient = {
  ...FcsPermissionClient,
  ...BcsPermissionClient
};

export function initFlagsPermissionClient() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureClient", FcsPermissionClient);
  BcsFlag.register("featureClient", BcsPermissionClient);
}
